import { AdonisIdentity } from "../../adonis.types";
import { getPersonaImage } from "../../assets/getPersonaImage";

export interface AssistantHeaderProps {
  persona: AdonisIdentity;
  isTyping: boolean;
}

/**
 * AssistantHeader component for rendering the assistant's avatar, name, and typing indicator.
 * Handles the visual header section of assistant messages including typing state.
 */
export const AssistantHeader = ({
  persona,
  isTyping,
}: AssistantHeaderProps) => {
  const renderTypingIndicator = () => {
    return (
      <div className="flex gap-1">
        <div
          data-testid="typing-dot"
          className="typing-dot h-2 w-2 rounded-full bg-gray-400"
        ></div>
        <div
          data-testid="typing-dot"
          className="typing-dot h-2 w-2 rounded-full bg-gray-400"
        ></div>
        <div
          data-testid="typing-dot"
          className="typing-dot h-2 w-2 rounded-full bg-gray-400"
        ></div>
      </div>
    );
  };

  return (
    <div className="assistant-header flex items-center gap-2 pb-2">
      <div className="flex">
        <img
          src={getPersonaImage(persona.name).logo}
          alt={persona.name}
          className="h-6 w-6 rounded-full"
        />
      </div>

      {isTyping ? (
        renderTypingIndicator()
      ) : (
        <h4 className="text-[11px] font-bold uppercase">
          {persona.name} • AI advisor
        </h4>
      )}
    </div>
  );
};
